<script>
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    mapConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      map: null,
    }
  },
  async mounted() {
    this.initializeMap()
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
    },
  },
}
</script>

<template>
  <div>
    <div
      ref="googleMap"
      class="googlemap"
    ></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>
